$(function () {
  let section = $('#seccionProductos')
  if (section.get(0) == null) {
    return
  }
  let vueApp = new Vue({
    el: section.get(0),
    data: {
      loader: false,
      filtros: { page: 1, tipo_pago_id: null, buscar: null },
      productos: [],
      modalTitulo: 'Nuevo producto',
      producto: {},
      precios: [],
      programarPrecios: false,
      limitarExistencias: false
    },
    mounted() {
      this.getProductos()
    },
    methods: {
      getProductos(pagina = null) {
        if (this.loader) {
          return
        }
        if (pagina != null) {
          this.filtros.page = pagina
        }
        this.loader = true
        axios
          .get('/admin/productos/json', {
            params: this.filtros,
          })
          .then((response) => {
            vueApp.loader = false
            if (response.data.error) {
              swal(response.data.error, "", "info")
              return
            }
            vueApp.productos = response.data.productos.data;
            vueApp.filtros.total = response.data.productos.total;
            vueApp.filtros.per_page = response.data.productos.per_page;
            vueApp.filtros.from = response.data.productos.from;
            vueApp.filtros.to = response.data.productos.to;
          })
          .catch((error) => {
            vueApp.loader = false
            swal("Ocurrió un error inesperado", "", "info")

          })
      },
      eliminar(id) {
        swalQ("¿Eliminar registro?", "", "warning").then((ok) => {
          if (ok) {
            axios
              .delete('/admin/productos/' + id)
              .then(function (response) {
                if (response.data.error) {
                  swal(response.data.error, "", "info")
                  return
                }
                vueApp.getProductos(1)
              })
              .catch((error) => {
                swal("Ocurrió un error inesperado", "", "info")
              })
          }
        })
      },
      removerPrecio(index){
        this.precios.splice(index, 1)
        this.validar()
      },
      agregarPrecio(){
        this.precios.push({
          fecha: null,
          precio: null
        })
        this.validar()
      },
      agregar() {
        $('#formProducto')[0].reset()
        this.precios = Object.assign([], [])
        this.programarPrecios = false
        this.limitarExistencias = false
        this.producto = Object.assign({}, {tipo_pago_id: null, activo: true})
        this.modalTitulo = 'Nuevo producto'
        $('#modalProducto').modal('show')
        this.validar()
      },
      editar(producto) {
        this.producto = Object.assign({}, producto)
        this.limitarExistencias = this.producto.inventario != null
        this.programarPrecios = this.producto.precios.length > 0
        this.precios = Object.assign([], this.producto.precios)
        this.modalTitulo = 'Editar producto'
        $('#modalProducto').modal('show')
        this.validar()
      },
      validar() {
        this.$nextTick(() => {
          $('#formProducto').validarForm((form) => {
            vueApp.guardar(form)
          })
        })
      },
      guardar(form) {
        $('#btnGuardar').loader('show')
        let formData = new FormData(form)
        if(this.precios.length > 0){
          formData.append("precios", JSON.stringify(this.precios))
        }
        axios
          .post('/admin/productos/guardar', formData)
          .then((respuesta) => {
            $('#btnGuardar').loader('hide')
            if (respuesta.data.error) {
              swal(respuesta.data.error, "", "info")
              return
            }
            swal("Registro guardado correctamente", "", "success")
            $('#modalProducto').modal('hide')
            vueApp.getProductos(1)
          })
          .catch((error) => {
            console.log(error)
            $('#btnGuardar').loader('hide')
            swal("Ocurrió un error inesperado", "", "info")
          })
      },
    },
  })
})
